import './../scss/angular-calendar.scss';
export * from './index';


// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/index.umd.ts